import { cn } from "@design-system/utils";
import { Loader2 } from "lucide-react";
import React, { ComponentProps } from "react";

interface LoaderProps extends Omit<ComponentProps<typeof Loader2>, "ref"> {
  size?: number;
  "aria-label"?: string;
}

function Loader({
  className,
  size = 24,
  "aria-label": ariaLabel = "Loading",
  ...props
}: LoaderProps) {
  return (
    <Loader2
      {...props}
      size={size}
      role="status"
      aria-label={ariaLabel}
      className={cn("text-foreground-neutral-muted animate-spin", className)}
    />
  );
}

export { Loader };
export type { LoaderProps };
